import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

import { PeticionService } from './../../../services/peticion.service';

import { LogsNav, Petition, User } from './../../../interfaces/interfaces.index';
import { LogsService, PersonaService } from 'src/app/services/services.index';
import { firstValueFrom } from 'rxjs';
import Swal from 'sweetalert2';
import { swalError } from 'src/app/shared';
import { resolvePetitionUserId } from 'src/app/shared/config/commons';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-capacidad-pago-proceso',
  templateUrl: './capacidad-pago-proceso.component.html',
  styleUrls: ['./capacidad-pago-proceso.component.css']
})
export class CapacidadPagoProcesoComponent implements OnInit {

  nextUrl = '';
  previousUrl = '';
  currentUrl = '';
  routeNumber;
  selPetition: Petition;
  personType = "Natural";
  currentPetitionUserId = Number(sessionStorage.getItem('selectedUserIdFromBandeja') || sessionStorage.getItem('AdjudgedUserId')) || 0;

  constructor(
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private petition : PeticionService,
    private logService: LogsService,
    private personaService: PersonaService,
    private userServices: UserService,
    public SpinnerService: NgxSpinnerService
  ) { }

  async ngOnInit() {
    this.addLogsNav();
    this.routeNumber = this.route.snapshot.paramMap.get('id');
    this.selPetition = JSON.parse(sessionStorage.getItem('selPetition')) as Petition;

    this.currentPetitionUserId = resolvePetitionUserId(this.selPetition, this.userService.user?.id);

    if (this.currentPetitionUserId) {
      sessionStorage.setItem('AdjudgedUserId', this.currentPetitionUserId.toString());
      this.userService.currentPetitionUserId = this.currentPetitionUserId;
    }

    this.SpinnerService.show();
    await firstValueFrom(this.personaService.getPeopleByUser(this.currentPetitionUserId ?? this.userService.user.id)).then(res => {
      if(res.typeOfIdentity.trim() === "N" || res.typeOfIdentity.trim() === "NIT") {
        this.personType = "Juridical"
      }
      this.SpinnerService.hide();
    }).catch(err => this.handleError(err));

    if (this.routeNumber === '1'){
      if(this.personType === "Juridical") {
        this.nextUrl = 'estudio-capacidad-pago';
      }
      else {
        this.nextUrl = 'capacidad-pago';
      }
    }
    else if(this.routeNumber === '2') {
      this.nextUrl = 'seleccion-vehiculo/1';
    }
    else{
      this.nextUrl = 'proceso';
    }
  }

  addLogsNav(){
    const logNav: LogsNav = {
      logType: 'Log de Navegación',
      visitedPage: location.href,
      userId: this.userService.user.id,
      petitionId: 0,
      stepCompleted: ''
    };

  }
  /**
   * @return process petition by actual user
   */

  next() {
    this.router.navigate([this.nextUrl]);
  }

  cancelProcess() {

    switch(this.selPetition.processId) {
      case 10:
        this.router.navigate(['/desistir-nominacion']);
        break;
      default:
        this.router.navigate(['/opciones-capacidad-pago']);
        break;
    }
  }
  onBack() {
    if (this.routeNumber === '1'){
      this.router.navigate([`proceso`]);
    }
    else if(this.routeNumber === '2') {
      this.router.navigate([`/solicitudes/inicio/usuario`]);
    }
  }

  handleError = (err) => {
    this.SpinnerService.hide();
    Swal.fire(swalError('Ha ocurrido un error', err?.userMessage));
  }
}
